import axios from 'axios';
import { GET, POST, aicaBaseUrl, polusBaseUrl } from '../../utils/axios-interceptor';
import { AicaHistoryResponse, ManagementProfileHistoryResponse, HistoryDrawerState } from '../../types/ownerHistory';
import { HISTORY_DRAWER_API_PATHS } from './constants';

export type FetchHistoryPayload = {
    referenceId: string;
    key: string;
    assesseeOrgId?: string;
    historySource?: HistoryDrawerState['historySource'];
};

// Additive routing (GF-6): historySource absent/'ACCOUNT' keeps today's unscoped
// `account/getHistory` call for the Leads owner-history drawer, untouched. Management
// Profile custom fields route through polus BEFE — same {requestPayload}
// envelope + polusBaseUrl as getManagementProfilesV2Data. assesseeOrgId is still sent:
// aica validates it against the caller's PNO, which it now reads from the
// Cerberus-verified MDC value rather than a forgeable header.
export const fetchHistory = (payload: FetchHistoryPayload) => {
    if (payload.historySource === 'MANAGEMENT_PROFILE') {
        return axios<ManagementProfileHistoryResponse>({
            baseURL: polusBaseUrl,
            url: HISTORY_DRAWER_API_PATHS.UW_AUDIT_HISTORY,
            method: POST,
            data: {
                requestPayload: {
                    assesseeOrgId: payload.assesseeOrgId,
                    managementProfileId: payload.referenceId,
                    fieldKey: payload.key,
                },
            },
        });
    }

    return axios<AicaHistoryResponse>({
        url: HISTORY_DRAWER_API_PATHS.GET_HISTORY,
        method: GET,
        params: { referenceId: payload.referenceId, key: payload.key },
        baseURL: aicaBaseUrl,
    });
};
